import React from "react";
import TableRow from "./TableRow";
import TableHeadItem from "./TableHeadItem";
import "./table.scss";
const Table = ({ theadData, tbodyData, customClass }) => {
  return (
      <div className="customTableClass">
          <div className="tableWrapperBlock">
        <table>
          <thead>
            <tr>
              {theadData.map((item, index) => {
                return <TableHeadItem key={index} item={item} />;
              })}
            </tr>
          </thead>
          <tbody>
            {tbodyData.map((item, index) => {
              return <TableRow key={index} data={item} />;
            })}
          </tbody>
        </table>
          </div>
      </div>
  );
};

export default Table;
